import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { useState, useMemo, useCallback } from 'react';
import { countBy } from 'lodash-es';
export function useRowSelection(param) {
    let { items } = param;
    const [selected, setSelected] = useState({});
    const numSelected = useMemo(()=>{
        var _countBy_true;
        return (_countBy_true = countBy(selected).true) !== null && _countBy_true !== void 0 ? _countBy_true : 0;
    }, [
        selected
    ]);
    const numVisibleSelected = useMemo(()=>{
        const visibleIds = new Set(items.map((item)=>item.id));
        return Object.entries(selected).filter((param)=>{
            let [id, val] = param;
            return val && visibleIds.has(id);
        }).length;
    }, [
        selected,
        items
    ]);
    const onToggleAllSelection = useCallback((selectAll)=>{
        if (selectAll) {
            setSelected((prev)=>_object_spread({}, prev, Object.fromEntries(items.map((item)=>[
                        item.id,
                        true
                    ]))));
        } else {
            setSelected({});
        }
    }, [
        items
    ]);
    const getSelectedIds = useCallback(()=>{
        return Object.entries(selected).filter((param)=>{
            let [, isSelected] = param;
            return isSelected;
        }).map((param)=>{
            let [id] = param;
            return id;
        });
    }, [
        selected
    ]);
    const clearSelection = useCallback(()=>{
        setSelected({});
    }, []);
    return {
        selected,
        numSelected,
        numVisibleSelected,
        setSelected,
        onToggleAllSelection,
        getSelectedIds,
        clearSelection
    };
}
